import React from 'react';

import type { TrackingService } from '../feature-service-types';

export const TrackingContext = React.createContext<TrackingService>({} as TrackingService);
